import firebase from "../firebase";

export default function({ stageId, roomId, officeId, visitId, phone, patient }) {

    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "patientTrackingUser",
        funcName: "smsMessages",
        data: {
            officeId,
            visitId,
            phone,
            stageId, 
            roomId,
            patient
        }
    });
}
